import {AfterViewInit, Component, inject, ViewChild, ViewContainerRef} from '@angular/core';
import {TipoMensajesService} from "../../../core/services/tipo-mensajes.service";
import {CrearComponenteDinamicoService} from "../../../core/services/crear-componente-dinamico.service";

@Component({
  selector: 'app-dinamico-host',
  imports: [],
  template: `
    <ng-template #dialogContainer></ng-template>`
})
export class DinamicoHostComponent implements AfterViewInit {
  @ViewChild('dialogContainer', {read: ViewContainerRef, static: true})
  public dialogContainer!: ViewContainerRef;

  private tipoMensajesService = inject(TipoMensajesService);
  private crearComponentesDinamicos = inject(CrearComponenteDinamicoService);

  constructor() {
  }

  ngAfterViewInit(): void {
    this.tipoMensajesService.setContainer(this.dialogContainer);
    this.crearComponentesDinamicos.setContainer(this.dialogContainer);
  }
}
